import React, { Component } from 'react';
import ReactDOM from 'react-dom/client';
import { connect } from 'react-redux';
import { Delete as DeleteIcon } from '@mui/icons-material';
import WithRouter from 'custom/withRouter';
import LOOKUP from 'constants/lookup';
import { selectComboModel } from 'selectors/entitySelector';
import util from 'library/util';
import { comboEditCrumb } from 'utils/breadcrumbInfo';
import { formError, formInput, initializeComboForm, clearDialogItemsCombo, clearFormInput, clearFormErrors } from 'actions/FormActions';
import { showSnackbar, showError } from 'actions/CommonActions';
import { getProducts, getCategories, getCombo, saveCombo } from 'actions/EntityActions';
// Basic Components
import Button from 'screens/components/basic/Button';
import CardSimple from 'screens/components/basic/CardSimple';
import ToggleInput from 'screens/components/basic/ToggleInput';
import TextInput from 'screens/components/basic/TextInput';
import DecimalInput from 'screens/components/basic/DecimalInput';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import Barcode from 'screens/components/basic/Barcode';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import SelectInput from 'screens/components/basic/SelectInput';
import TimePickerInput from 'screens/components/basic/TimePickerInput';
import CheckInput from 'screens/components/basic/CheckInput';
import PageHeader from 'screens/components/basic/PageHeader';
import PageBottomWithButtons from 'screens/components/basic/PageBottomWithButtons';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
// Advanced Components
import DialogInput from 'screens/components/advanced/DialogInput';
import GenericTable from 'screens/components/advanced/GenericTable';

class ComboSave extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            status: '',
            activePage: 1,
            itemsPerPage: 25,
            dialogProducts: false,
            errorSelectedCategories: false,
            errorNoAddedItems: false,
            products: [],
            orderBy: "ASC",
            sortBy: "Id"
        };
        this.ws = null;
    }

    componentWillMount = () => {
        const comboId = this.props.params.id;
        if (comboId) {
            this.setState({ status: "EDIT" });
            this.props.getCombo(comboId, this.props.branchId);
        }
        else {
            this.setState({ status: "ADD" });
            this.props.init(this.props.name);
        }
        try {
            this.initWebSocket();
        } catch (err) {
            console.log(`WebSocket Error: ${err}`);
            this.initWebSocket();
        }
        this.props.getCategories();
    }

    componentWillUnmount = () => {
        this.props.init(this.props.name);
        this.props.clearFormErrors();
        this.ws.close(1000);
    }

    componentWillReceiveProps = (newProps) => {
        if (newProps.saveTimeStamp && this.props.saveTimeStamp !== newProps.saveTimeStamp) {
            if (newProps.saveSuccess === true)
                this.saveSuccess();
            else
                this.saveFailure(newProps.saveError);
        }

        if ((this.props.combo === null || this.props.combo === undefined) && newProps.combo) {
            this.setState({
                products: [...newProps.combo.products]
            });
        }
    }

    saveSuccess = () => {
        this.props.showSnackbar(this.state.status === "EDIT" ? LOOKUP.combo.messages.editedMessage : LOOKUP.combo.messages.createdMessage);
        this.redirectToCampaignList();
    }

    saveFailure = (msg) => {
        this.props.showError((
            <div>
                <p>Combo could not be saved.</p>
                <p>{msg}</p>
            </div>)
            || LOOKUP.combo.messages.saveErrorMessage);
    }

    redirectToCampaignList() {
        this.props.navigate("/manage/combo");
    }

    closeProductsDialog = () => {
        this.setState({ dialogProducts: false });
        this.props.clearDialogItemsCombo();
    }

    openProductsDialog = () => {
        this.setState({ dialogProducts: true });
    }

    searchProducts = () => {
        const model = {
            page: this.state.activePage,
            itemsPerPage: this.state.itemsPerPage,
            searchText: this.props.comboProductSearchText || "",
            categoryId: this.props.comboProductSearchCategory || "",
            sku: this.props.comboProductSearchSKU || "",
            priceMatrixId: null,
            status: 'Active',
            typeId: null,
            orderBy: this.state.orderBy,
            sortBy: this.state.sortBy,
            branchId: this.props.branchId
        };
        this.props.getProducts(model);
    }

    search = () => {
        this.setState({ activePage: 1 }, this.searchProducts);
    }

    changePage = e => {
        this.setState({ activePage: e }, this.searchProducts);
    }

    removeProduct = (product) => {
        const products = this.state.products.filter(p => p.id !== product.id);
        this.setState({ products: products });
    }

    addProductToCombo = (product) => {
        let products = [...this.state.products];
        products.push(product);
        this.setState({ products: products }, this.validateItems);
    }

    saveCombo = () => {
        const p = this.props;
        let combo = p.comboModel;
        const comboId = this.props.params.id || 0;
        let quantityValidator = true;

        const validators = [
            [`${p.name}Name`, combo => (combo.Name && combo.Name !== null && combo.Name !== ""), "Name"],
            [`${p.name}Price`, combo => (combo.Price && combo.Price !== null && combo.Price !== 0), "Price"]
        ];

        const isFormValid = util.validate(validators, combo, this.props.formError);
        const isItemsValid = this.validateItems();

        if (isItemsValid && isFormValid) {
            combo.Id = comboId;
            let comboProducts = [];
            this.state.products.map(item => {
                let quantity = this.props.form[`${p.name}_${item.id}`];
                if (quantity > 0) {
                    comboProducts.push({ Id: parseInt(item.id), Quantity: quantity });
                } else {
                    this.props.showError('Product quantity must greater than 0!');
                    quantityValidator = false;
                    return;
                }
            });
            combo.Products = comboProducts;
            if (quantityValidator) {
                this.props.saveCombo(combo);
            }
        }
    }

    validateItems = () => {
        const isValid = (this.state.products.length > 0);
        this.setState({ errorNoAddedItems: !isValid });
        return isValid;
    }

    printLabel = (barcode) => {
        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            const model = {
                command: "PRINT BARCODE",
                data: JSON.stringify([{
                    CompanyName: this.props.storeName + " Combo",
                    ProductName: "Combo Name: " + this.props.combo.name,
                    Quantity: 1,
                    Barcode: barcode,
                    NumberOfCopies: 1,
                    Price: this.props.combo.price
                }])
            };
            console.log(model);
            this.ws.send(JSON.stringify(model));
        } else {
            const toPrint = ReactDOM.createRoot(document.getElementById('to-print'));
            toPrint.render (<Barcode code={barcode} format={"CODE128B"} width={2} print={true} />);
        }
    }

    initWebSocket = () => {
        try {
            this.ws = new WebSocket("ws://127.0.0.1:5000/");
            this.ws.binaryType = "arraybuffer";

            this.ws.onopen = function () {
                if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                    // console.log('ws connected');
                }
            };

            this.ws.onerror = () => {
            };

            this.ws.onclose = (event) => {
                if (event.code !== 99999) {
                    console.log("Websocket is Locked!");
                }
            };

            this.ws.onmessage = (event) => {
                let response = event.data;
                let content = response.split(',');
                let responseType = content[0];
                let value = content[1];

                if (responseType === "LABELPRINTER") {
                    if (value === 'OFFLINE') {
                        this.props.showError("The label printer is offline. Please, Contact the support team.");
                    }
                }

            };

            window.onbeforeunload = function () {
                if (this.ws) {
                    const model = {
                        Command: "CLOSE",
                        Data: null
                    };

                    this.ws.send(JSON.stringify(model));
                    this.ws.close(1000);
                    window.productWebSocket = null;
                }
            };

            window.productWebSocket = this.ws;
        }
        catch (err) {
            console.error(`ERROR ON INIT FUNCTION CATCH: ${err}`);
        }
    }

    clearTime = () => {
        this.props.clearFormInput(`${this.props.name}StartTime`);
        this.props.clearFormInput(`${this.props.name}EndTime`);
        this.props.formError(`${this.props.name}StartTime`, ``);
        this.props.formError(`${this.props.name}EndTime`, ``);
    }

    render() {
        const s = this.state;
        const p = this.props;
        let categories = (this.props.categoriesList || []).map(c => ({
            text: c.name,
            value: c.id.toString()
        })
        );
        const campaignDay = LOOKUP.campaign.day;

        const productsTable = p.products.map((item, index) => {
            return {
                sku: item.sku,
                name: item.name,
                typeCategory: `[${item.type}] ${item.category}`,
                price: item.price,
                ...item,
                icons: s.products.filter(p => p.id == item.id).length > 0
                    ? (
                        <Button name={`${this.props.name}${item.id}RemoveProductFromCombo`}
                            id={`buttonAddToCombo-${index}`}
                            type="IconCheckButton"
                            className="campaign_add_btn_clicked"
                            onTouchTap={() => this.removeProduct(item)} />)
                    : (
                        <Button name={`${this.props.name}${item.id}AddProductToCombo`}
                            id={`buttonAddToCombo-${index}`}
                            type="IconCheckButton"
                            className="campaign_add_btn"
                            onTouchTap={() => this.addProductToCombo(item)} />
                    )
            };
        });

        const productsAddedTable = s.products.map((item, index) => {
            return {
                sku: item.sku,
                name: item.name,
                quantity:
                    item.typeId !== 1 ?
                        <TextInput
                            name={`${p.name}_${item.id}`}
                            type="number"
                            fullWidth={true}
                            floatingLabelText={`${LOOKUP.combo.quantity.label}`}
                            label={`${LOOKUP.combo.quantity.label}`}
                            hintText={`${LOOKUP.combo.quantity.hintText}`}
                            required
                        />
                        :
                        <DecimalInput
                            name={`${p.name}_${item.id}`}
                            fullWidth={true}
                            floatingLabelText={`${LOOKUP.combo.quantity.label}`}
                            label={`${LOOKUP.combo.quantity.label}`}
                            hintText={`${LOOKUP.combo.quantity.hintText}`}
                            min={0}
                            max={1000000}
                            required
                        />,
                icons:
                    <Button
                        key={index}
                        name={`${this.props.name}${item.id}RemoveItemFromCombo`}
                        type="IconButton"
                        className="glyphicon glyphicon-remove-circle"
                        onTouchTap={() => this.removeProduct(item)}
                        icon={<DeleteIcon/>}
                    />
            };
        });

        return (
            <Grid headerContent={comboEditCrumb} >
                <PageHeader title="Manage Combo"/>
                <CardSimple title="Combo" className="p-1">
                    <div>
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <TextInput
                                    name={p.name + "Name"}
                                    label={LOOKUP.combo.name.label}
                                    floatingLabelText={LOOKUP.combo.name.label}
                                    hintText={LOOKUP.combo.name.hintText}
                                    fullWidth={true}
                                    maxLength={50}
                                    required />
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <DecimalInput
                                    name={`${p.name}Price`}
                                    fullWidth={true}
                                    floatingLabelText={`${LOOKUP.combo.price.label} ($)`}
                                    label={`${LOOKUP.combo.price.label} ($)`}
                                    hintText={`${LOOKUP.combo.price.hintText} ($)`}
                                    min={0}
                                    max={1000000}
                                    required />
                            </div>
                        </div> {/* .row */}
                        <div className="row">
                            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                                <DatePickerInput
                                    id="inputStartDate"
                                    name={p.name + "StartDate"}
                                    floatingLabelText={LOOKUP.campaign.startDate.label}
                                    hintText={LOOKUP.campaign.startDate.hintText}
                                    fullWidth={true}
                                />
                            </div>
                            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                                <DatePickerInput
                                    name={p.name + "EndDate"}
                                    floatingLabelText={LOOKUP.campaign.endDate.label}
                                    hintText={LOOKUP.campaign.endDate.hintText}
                                    fullWidth={true}
                                />
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                                {
                                    campaignDay.map((item, index) => {
                                        return (
                                            <div className="campaign_day" key={index}>
                                                <CheckInput
                                                    name={p.name + "WeekDay-" + item.text}
                                                    text={item.name}
                                                    value={item.text}
                                                />
                                            </div>
                                        );
                                    })
                                }
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                                <TimePickerInput
                                    name={p.name + "StartTime"}
                                    floatingLabelText={LOOKUP.campaign.startTime.label}
                                    hintText={LOOKUP.campaign.startTime.hintText}
                                    fullWidth={true}
                                    required
                                />
                            </div>
                            <div className="col-xs-6 col-sm-6 col-md-6 col-lg-2 col-xl-2">
                                <TimePickerInput
                                    name={p.name + "EndTime"}
                                    floatingLabelText={LOOKUP.campaign.endTime.label}
                                    hintText={LOOKUP.campaign.endTime.hintText}
                                    fullWidth={true}
                                    required
                                />
                            </div>
                            <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-1">
                                <Button
                                    type="IconClearButton"
                                    label="Clear Time"
                                    fullWidth={true}
                                    onTouchTap={() => this.clearTime()}
                                />
                            </div>
                        </div>
                        <div className="row align-items-end">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 campaign_status_group">
                                <ToggleInput
                                    name={p.name + "Status"}
                                    label={LOOKUP.campaign.status}
                                    className="toggle-active-inactive btnToggleLabel"
                                />
                            </div>
                            {
                                this.state.status === "EDIT" ?
                                    <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6 justify-">
                                        <Button className="printBtn"
                                            type="PrintButton"
                                            label="Label"
                                            onTouchTap={() => this.printLabel('C' + (`00000000000${this.props.combo.id}`).slice(-11))}
                                        />
                                    </div> : ""
                            }
                        </div>
                    </div>
                </CardSimple>
                <CardSimple className="mt-2 p-1">
                    <div className="row-flex justify-content-end">
                        <div className="col-lg-9">
                            <h4>Items added to Combo</h4>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
                            <Button
                                id="buttonAddItemsToCombo"
                                type="FloatButton"
                                label="Add Items To Combo"
                                fullWidth={true}
                                className="btnNewBrandPOS"
                                onTouchTap={() => this.openProductsDialog()}
                            />
                        </div>
                    </div>
                    <br />
                    {
                        s.products.length === 0 ? (
                            <p>No items added to this combo</p>
                        ) : null
                    }
                    {
                        s.errorNoAddedItems ? (
                            <p className="danger">Is necessary to add at least one item to the combo</p>
                        ) : null
                    }
                    {
                        s.products.length > 0 ? (
                            <React.Fragment>
                                <p className="mb-1">Products Added: </p>
                                <GenericTable
                                    compName="productsAddedTable"
                                    adjustForCheckbox={false}
                                    displaySelectAll={false}
                                    displayRowCheckbox={false}
                                    enableSelectAll={false}
                                    multiSelectable={false}
                                    selectable={false}
                                    columns={LOOKUP.combo.productAddedTableColumns}
                                    rows={productsAddedTable}
                                    stripedRows={true}
                                />
                            </React.Fragment>
                        ) : null
                    }
                </CardSimple>
                <PageBottomWithButtons>
                    <Button
                        name="buttonSave"
                        className="pull-right btnNewBrandPOS"
                        label={LOOKUP.campaign.controls.saveButon}
                        primary={true}
                        onTouchTap={() => this.saveCombo()}
                    />
                    <Button
                        type="CancelButton"
                        name="buttonCancel"
                        className="pull-right btn-space btnCancelOperation"
                        label={LOOKUP.common.cancel.text}
                        onTouchTap={() => this.redirectToCampaignList()}
                    />
                </PageBottomWithButtons>
                {/* DIALOG PRODUCTS */}
                <DialogInput
                    title={<DialogHeaderWithClose text="Add To Combo" handleClose={() => this.closeProductsDialog()} />}
                    modal={true}
                    autoScrollBodyContent={true}
                    style={{ zIndex: '980' }}
                    contentStyle={{ width: '95%', maxWidth: 'none' }}
                    open={this.state.dialogProducts}>
                        <div className="row">
                            <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 input_no_padding">
                                <TextInput
                                    name={`${p.name}comboProductSearchText`}
                                    fullWidth={true}
                                    label={LOOKUP.combo.filters.productName.label}
                                    floatingLabelText={LOOKUP.combo.filters.productName.label}
                                    hintText={LOOKUP.combo.filters.productName.hintText} />
                            </div>
                            <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 input_no_padding">
                                <TextInput
                                    name={`${p.name}comboProductSearchSKU`}
                                    fullWidth={true}
                                    label={LOOKUP.combo.filters.productSKU.label}
                                    floatingLabelText={LOOKUP.combo.filters.productSKU.label}
                                    hintText={LOOKUP.combo.filters.productSKU.hintText} />
                            </div>
                            <div className="col-xs-4 col-sm-4 col-md-4 col-lg-3 col-xl-4 input_no_padding">
                                <SelectInput
                                    name={`${p.name}comboProductSearchCategory`}
                                    label={LOOKUP.product.filters.category.label}
                                    className="smallerPlaceholder"
                                    floatingLabelText={LOOKUP.product.filters.category.label}
                                    hintText={LOOKUP.product.filters.category.hintText}
                                    options={categories}
                                    fullWidth={true} />
                            </div>
                            <div className="col-lg-2">
                                <br />
                                <Button
                                    className="pull-right"
                                    name="searchProductDialog"
                                    label="Search"
                                    primary={true}
                                    onTouchTap={() => this.search()} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <GenericTable
                                    className="table_center tableHeaderwhiteColorFont"
                                    compName="productDialogListTable"
                                    adjustForCheckbox={false}
                                    displaySelectAll={false}
                                    displayRowCheckbox={false}
                                    enableSelectAll={false}
                                    multiSelectable={false}
                                    selectable={false}
                                    stripedRows={true}
                                    columns={LOOKUP.combo.productDialogTableColumns}
                                    rows={productsTable} />
                                <Pagination
                                    length={p.productsLength || 0}
                                    itemsPerPage={s.itemsPerPage}
                                    activePage={s.activePage}
                                    onPageChange={(e) => this.changePage(e)} />
                            </div>
                        </div>
                </DialogInput>
            </Grid>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        combo: state.entity.combo,
        comboModel: selectComboModel(state, ownProps.name),
        products: state.entity.productList || [],
        productsLength: state.entity.productListLength,
        saveSuccess: state.form[`${ownProps.name}SaveSuccess`],
        saveError: state.form[`${ownProps.name}SaveError`],
        saveTimeStamp: state.form[`${ownProps.name}SaveTimeStamp`],
        branchId: state.common.branchId,
        comboProductSearchText: state.form[`${ownProps.name}comboProductSearchText`],
        comboProductSearchSKU: state.form[`${ownProps.name}comboProductSearchSKU`],
        comboProductSearchCategory: state.form[`${ownProps.name}comboProductSearchCategory`],
        storeName: state.common.store.name,
        form: state.form,
        categoriesList: state.entity.categoriesList || [],
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveCombo: (model) => dispatch(saveCombo(model, ownProps.name)),
        getCombo: (id, branchId) => dispatch(getCombo(id, branchId, ownProps.name)),
        init: (compName) => dispatch(initializeComboForm(compName)),
        formError: (name, error) => dispatch(formError(name, error)),
        showSnackbar: (message) => dispatch(showSnackbar(message)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getProducts: (model) => dispatch(getProducts(model)),
        getCategories: () => dispatch(getCategories(parseInt(localStorage.getItem('TECHPOS_SELECTED_BRANCH')))),
        clearDialogItemsCombo: () => dispatch(clearDialogItemsCombo(ownProps.name)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        clearFormErrors: () => dispatch(clearFormErrors())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(ComboSave));
